/**
 * Route Overview — status badge resolution.
 *
 * Leg rows keep the portal's customer-facing order status badge. Stop rows read the truck's
 * relationship to the stop (Upcoming / Arrived / Departed). WALHQ's post-delivery paperwork ladder
 * (pending POD / pending carrier bill) is internal bookkeeping and is deliberately not shown here.
 */
import { getBadgeLabelByOrderStatus, getOrderStatusBadgeType } from 'src/constants/common';
import { BadgeType } from 'src/interface/common';

import { getStopState, IStopState } from './legOverview.helpers';

type TFn = (key: string, options?: Record<string, any>) => string;

interface ILegStatusBadge {
    label: string;
    type: BadgeType;
}

const STOP_STATE_BADGE_TYPE: Record<IStopState, BadgeType> = { upcoming: 'gray', arrived: 'orange', departed: 'success' };
const STOP_STATE_LABEL_KEY: Record<IStopState, string> = {
    upcoming: 'Orders.Route_Overview_Table.Stop_State_Upcoming',
    arrived: 'Orders.Route_Overview_Table.Stop_State_Arrived',
    departed: 'Orders.Route_Overview_Table.Stop_State_Departed',
};

export const getLegStatusBadge = (leg: any): ILegStatusBadge | null => {
    if (!leg?.orderStatus) return null;

    return { label: getBadgeLabelByOrderStatus(leg.orderStatus), type: getOrderStatusBadgeType(leg.orderStatus) as BadgeType };
};

export const getStopStateBadge = (leg: any, legs: any[], t: TFn): ILegStatusBadge => {
    const state = getStopState(leg, legs);

    return { label: t(STOP_STATE_LABEL_KEY[state]), type: STOP_STATE_BADGE_TYPE[state] };
};
